import React from 'react';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import FileSelection from './components/FileSelection.jsx';
import ImportHistory from './components/ImportHistory.jsx';
import WaveformViewer from './components/WaveformViewer.jsx';
import useEcgImports from './hooks/useEcgImports.js';

export default function ECGViewer() {
  const ecg = useEcgImports();
  const handleSelect = ecg.start;
  const handleClear = ecg.clear;
  const handleCancel = ecg.cancel;
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        ECG-VIEWER
      </Typography>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <FileSelection
          onSelect={handleSelect}
          onClear={handleClear}
          onCancel={handleCancel}
          busy={ecg.busy}
          hasImports={ecg.imports.length > 0}
        />
        {ecg.busy && <LinearProgress sx={{ mt: 2 }} />}
        <ImportHistory imports={ecg.imports} />
      </Paper>
      <Paper variant="outlined" sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          ECG viewer
        </Typography>
        <WaveformViewer imports={ecg.imports} recordings={ecg.recordings} />
      </Paper>
    </Box>
  );
}
